module.exports = __webpack_public_path__ + "static/media/resume.40eeacfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/menu/resume.jpg
// module id = 153
// module chunks = 0